/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface GcpCloudRunJobResponse { 
    /**
     * Cloud run job name.
     */
    job_name?: string;
    /**
     * Cloud run job terminal condition state.
     */
    terminal_condition_state?: string;
    /**
     * Cloud run job terminal condition type.
     */
    terminal_condition_type?: string;
    /**
     * Cloud run job creation timestamp
     */
    create_time?: string;
    /**
     * Cloud run job deletion timestamp
     */
    delete_time?: string;
}

